import { CloseOutlined } from "@ant-design/icons";
import { Avatar, Button, Card, Col, Row, Typography } from "antd";
import { useSupporterSearch } from "hook/supporters/useSupporter";
import React from "react";
import { useSelector } from "react-redux";
import { defaultSupporterInfoSelector } from "store/user/(default)/supporter/default_supporter.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const SupporterInput = () => {
  // -------------------------- VAR -----------------------------
  const { handleRemoveSupporter } = useSupporterSearch();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const supporterInfo = useSelector(defaultSupporterInfoSelector);
  const email = supporterInfo?.email;
  const fullName = supporterInfo?.fullName || email;
  const avatar = email?.slice(0, 2);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!supporterInfo) return null;
  return (
    <Card size="small">
      <Row>
        <Col
          style={{
            display: "flex",
            alignItems: "center",
          }}
          xl={2}
          lg={2}
          md={4}
          xs={4}
        >
          <Avatar>{avatar}</Avatar>
        </Col>
        <Col xl={20} lg={20} md={18} xs={18}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography.Text style={{ color: "#555" }}>
              {fullName}
            </Typography.Text>
            <Typography.Text style={{ color: "#aeaeae" }}>
              {email}
            </Typography.Text>
          </div>
        </Col>
        <Col
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
          xl={2}
          lg={2}
          md={2}
          xs={2}
        >
          <Button
            onClick={handleRemoveSupporter}
            size="small"
            icon={<CloseOutlined />}
          />
        </Col>
      </Row>
    </Card>
  );
};
export default SupporterInput;
